import { Box } from "@mui/material"
import { WarningAmber } from '@mui/icons-material';

export const Warning = ({message, messageDetails}) => { 
  
    return (
        <Box width={'100%'} bgcolor="#FFFFFF" px="24px" pb="24px" borderRadius="6px">
            <Box minHeight="52px"></Box>
            <Box display="flex" flexDirection="column" gap="20px">
                <WarningAmber/>
                <Box color="#292C2F" fontSize={16} fontWeight={600} lineHeight="20px" >{message}.</Box>
                <Box color="#5B6167" fontSize={14} fontWeight={400} lineHeight="21px" >
                    {messageDetails}
                </Box>
            </Box>
        </Box>
    )
}
